import React, { useEffect, useState } from 'react';
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import Header2 from '../component/common/title';
import './sec-event.css'
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic27 from '../assets/pic27.png'
import pic28 from '../assets/pic28.png'
import { supabase } from '../supabase';
import './sec-event-content-mangement.css'
import Contentmangementnav from '../component/common/contentnav';

const Categorycontentmang = () => {


const [Categories, setCategories] = useState([]);

const [search, setSearch] = useState('');
const [filter, setFilter] = useState('');
const [sort, setSort] = useState('');

const [isSidebarOpen, setIsSidebarOpen] = useState(false);









useEffect(() => {
  const getAllCategories = async () => {
    const { data, error } = await supabase
      .from('Categories')
      .select('*');

    if (error) {
      console.log("CATEGORIES FETCH ERROR:", error);
      return;
    }

    setCategories(data || []);
  };

  getAllCategories();
}, []);













const filteredCategories = Categories
  .filter((item) => {
    const matchesSearch =
      item.Category_name?.toLowerCase().includes(search.toLowerCase());

    const matchesFilter =
      filter === "shown"
        ? item.show_on_homepage === true
        : filter === "hidden"
        ? item.show_on_homepage === false
        : true;

    return matchesSearch && matchesFilter;
  })






    return ( 
<section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                    <section className='information-container'>
                        <article className='header-cont-event'>
                           <Header2 
                            title="Landing Page Content"  
                            para="Manage featured events, FAQs, and testimonials"
                            />
                     
                        
                        </article>



<section className='container-table-and-section'>


                        <Contentmangementnav />



                        <section className='container-table-eventp'>
                            <fieldset className="input-wrapper">
                                <input 
                                  className='input-search'
                                    placeholder="Search events..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic25} className="search-icon" alt="search" />
                            </fieldset>
                            <fieldset className='container-inputs-event-p'>
                                  <div className="select-wrapper">
                                    <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic26} className="select-icon" alt="filter" />
                                <select
                                className="input-search select-style"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                >
                                      <option value="">Filter by</option>

                                        <option value="shown">Shown</option>
                                        <option value="hidden">Hidden</option>
                                </select>
                                </div>


                            </fieldset>



                                                 <div className="table-container" >
                                 <table className='table-table-concert-mangem'>
                                                                   
                            {filteredCategories.map((item) => { return <tbody key={item.id}>
                               
                                                                 <tr className="row-table2-contenttt">

                                                                 <label className="custom-checkboxl">
                                                                <input
                                                                type="checkbox"
                                                                checked={item.show_on_homepage}
                                                                onChange={async () => {

                                                                    
                                                                    const newValue = !item.show_on_homepage;

                                                                    await supabase
                                                                    .from('Categories')
                                                                    .update({ show_on_homepage: newValue })
                                                                    .eq('id', item.id);

                                                                    setCategories((prev) =>
                                                                    prev.map((cat) => cat.id === item.id
                                                                        ? { ...cat, show_on_homepage: newValue }
                                                                        : cat
                                                                    )
                                                                    );
                                                                }}
                                                                />

                                                                <span className="checkmarkcontent"></span>
                                                                <h3 className="SHOW">Show on homepage</h3>
                                                                </label>

                                                                <div className="main-info">
                                                                <h2 className="header-support">{item.Category_name}</h2>

                                             
                                                                </div>






                                                                            </tr>
                               
                               
                               
                               
                                                                   </tbody>
                                              })}
                                                               </table>
                                </div>

                                       




                        </section>







                    </section>

            </section>
            </section>
        </section>
     );
}
 
export default Categorycontentmang;